import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAccountClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M8.374 8.585c1.391-2.992 5-4.31 8.06-2.95 3.062 1.36 4.41 4.888 3.018 7.88C18.47 15.64 16.304 17 13.913 17c-2.348 0-4.496-1.326-5.504-3.4H0v-1.7c.052-.969.73-1.76 2.035-2.397 1.304-.637 2.939-.969 4.922-1.003.495 0 .965.043 1.417.085zM6.957 0C7.93.025 8.747.357 9.4.995c.652.637.974 1.436.974 2.405 0 .969-.322 1.768-.974 2.406-.652.637-1.47.952-2.443.952-.974 0-1.792-.315-2.444-.952-.652-.638-.974-1.437-.974-2.406 0-.969.322-1.768.974-2.405C5.165.356 5.983.024 6.957 0zm6.956 15.3c2.401 0 4.348-1.903 4.348-4.25S16.314 6.8 13.913 6.8s-4.348 1.903-4.348 4.25 1.947 4.25 4.348 4.25zm-.87-6.8h1.305v2.397l2.122 1.198-.653 1.105-2.774-1.563V8.5z"
	})
});
export default SvgAccountClock;
